<template>
    <survey-loader full-size />
</template>
<script src="./home.ts"></script>
